import clsx from 'clsx'
import Link from 'next/link'
import { useState } from 'react'

import { Button } from '@wartek-id/button'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog'
import { Icon } from '@wartek-id/icon'
import { Popover, PopoverContent, PopoverTrigger } from '@wartek-id/popover'
import { Text } from '@wartek-id/text'

import { formatDate } from 'utils/date'

export const SCHEDULE = [
  {
    day: 'Senin',
    topics: ['Pelatihan BCKS', 'Pelatihan BCPS', 'Pelatihan PM bagi KS dan PS'],
    zoomUrl:
      'https://telkomsel.zoom.us/j/94281401931?pwd=LAwens7MkhAtcsn0mcb3H7xb9Tywkx.1',
  },
  {
    day: 'Selasa',
    topics: [
      'Pendampingan Penyelenggaraan Seleksi Administratif dan Substantif',
      'Pelindungan PTK',
      'Peningkatan Kompetensi Tendik',
      'Beasiswa Program Mikro Kredensia School Leadership Program',
    ],
    zoomUrl:
      'https://telkomsel.zoom.us/j/93745991836?pwd=Fa2VFvp2m3igr54Pp9Xq9b806D4k9F.1',
  },
  {
    day: 'Rabu',
    topics: [
      'Penugasan Guru sebagai KS',
      'Pengelolaan Kinerja PS',
      'UKKJ JF PS',
    ],
    zoomUrl:
      'https://telkomsel.zoom.us/j/98504727720?pwd=PuotESxaM5Vuwcwvora11dae2QG5Sp.1',
  },
  {
    day: 'Kamis',
    topics: ['Pelayanan Umum, Humas, dan Kemitraan'],
    zoomUrl:
      'https://telkomsel.zoom.us/j/92230122504?pwd=Hx4CYLJQzz4m3FBdHjCseIvQeIbqbS.1',
  },
]

const getTodaySchedule = () => {
  const dayIndex = new Date().getDay() - 1
  if (dayIndex < 0 || dayIndex > 3) return null
  return SCHEDULE[dayIndex]
}

const ButtonKonsultasiDaring = () => {
  const [isScheduleOpen, setIsScheduleOpen] = useState(false)
  const todaySchedule = getTodaySchedule()

  return (
    <>
      <Popover className="flex-1 [&>div>div]:h-full [&>div]:h-full">
        <PopoverTrigger className="h-full w-full">
          <Button
            fullWidth
            color="white"
            size="sm"
            className="flex h-full items-center gap-1 whitespace-nowrap border !font-medium !outline-subdued"
          >
            <Icon fontSize="sm">videocam</Icon>Konsultasi Daring
          </Button>
        </PopoverTrigger>

        <PopoverContent anchor="bottom end" className="!p-4">
          <div className="w-96 space-y-3">
            <Text variant="heading-sm">
              Konsultasi Daring SIM KSPSTK (Zoom Call)
            </Text>

            <div className="space-y-3 rounded-md border border-blue-40 bg-surface-informational-subdued p-3">
              <Text variant="body-sm-bold">📅 Jam Operasional</Text>

              <div>
                <Text variant="body-sm-bold">Hari</Text>
                <Text variant="body-sm" color="subdued">
                  Senin - Kamis
                </Text>
              </div>

              <div>
                <Text variant="body-sm-bold">Jam</Text>
                <Text variant="body-sm" color="subdued">
                  08:00 - 09:00 WIB
                </Text>
              </div>

              <Text variant="body-sm" color="subdued">
                Jika ada permintaan konsultasi di luar jadwal di atas, silakan
                hubungi KSPSTK atau B/BGTK.
              </Text>
            </div>

            {todaySchedule && (
              <div className="space-y-2 rounded-md border border-subdued bg-surface-subdued p-4">
                <Text variant="body-sm-bold">
                  📌 Tema Hari {todaySchedule.day} ({todaySchedule.day},{' '}
                  {String(formatDate(new Date()))})
                </Text>

                <ul className="list-disc pl-5">
                  {todaySchedule.topics.map((topic) => (
                    <li key={topic}>
                      <Text variant="body-sm">{topic}</Text>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <Button
              fullWidth
              color="white"
              className="border !outline-subdued"
              onClick={() => setIsScheduleOpen(true)}
            >
              <Icon fontSize="sm" className="mr-2">
                calendar_today
              </Icon>
              Lihat Jadwal Lengkap
            </Button>

            {todaySchedule && (
              <Link
                href={todaySchedule.zoomUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-full"
              >
                <Button
                  fullWidth
                  className="flex h-full items-center gap-2 border !outline-subdued"
                >
                  <Icon color="inverse">videocam</Icon>Ikuti Konsultasi Daring
                </Button>
              </Link>
            )}
          </div>
        </PopoverContent>
      </Popover>

      <Dialog isOpen={isScheduleOpen} onClose={() => setIsScheduleOpen(false)}>
        <DialogOverlay />
        <DialogContent className="p-6">
          <DialogCloseButton />
          <Text variant="heading-md" className="mb-6">
            Jadwal Lengkap Konsultasi Daring
          </Text>

          <div className="space-y-4">
            {SCHEDULE.map((item, index) => {
              const isToday = index === new Date().getDay() - 1
              return (
                <div
                  key={item.day}
                  className={`rounded-lg border p-4 ${
                    isToday
                      ? 'border-blue-40 bg-surface-informational-subdued'
                      : 'border-subdued bg-surface-subdued'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <Text variant="body-sm-bold">
                      {isToday ? (
                        <span className="text-blue-700">
                          {item.day} (Hari Ini)
                        </span>
                      ) : (
                        item.day
                      )}
                    </Text>
                    <Text
                      variant="body-sm"
                      className={clsx(isToday && '!text-primary')}
                    >
                      08:00 - 09:00 WIB
                    </Text>
                  </div>
                  <ul className="mt-2 list-disc pl-5">
                    {item.topics.map((topic) => (
                      <li key={topic}>
                        <Text variant="body-sm">{topic}</Text>
                      </li>
                    ))}
                  </ul>
                </div>
              )
            })}
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ButtonKonsultasiDaring
